import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getFavouritesRequest(portalConfig, user) {
  const endpoint = await configRefs.apis.userdata.get();
  const res = await axios.get(`${endpoint}/api/FavoritesV2?userID=${encodeURIComponent(user.id)}&userInstitutionID=${encodeURIComponent(user.institution?.id ?? "")}&productID=${encodeURIComponent(portalConfig.id)}`);
  const pageIds = new Set(res.data.map(it => it.dynamicContent.version === "1" && it.dynamicContent.type === "page" ? it.dynamicContent.pageId : undefined).filter(Boolean));
  return res.data.filter(it => {
    if (it.dynamicContent.version !== "1") {
      return false;
    }

    // Data from cards did not correctly implement support from pages. As
    // such we must filter duplicates out.
    // See ADO #142943
    if (it.dynamicContent.type === "course" && pageIds.has(it.dynamicContent.courseId)) {
      return false;
    }
    return true;
  }).map(it => ({
    ...it.dynamicContent,
    createdAt: new Date(it.created * 1000),
    id: it.objectID
  }));
}

export { getFavouritesRequest };
//# sourceMappingURL=get-favourties.request.js.map
